import { render, staticRenderFns } from "./exccelInfo.vue?vue&type=template&id=ba939364&scoped=true&"
import script from "./exccelInfo.vue?vue&type=script&lang=js&"
export * from "./exccelInfo.vue?vue&type=script&lang=js&"
import style0 from "./exccelInfo.vue?vue&type=style&index=0&id=ba939364&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba939364",
  null
  
)

export default component.exports